import React from "react";
import Styled from "styled-components";
function ProjectCard({ value, link,proName }) {
  const handleMouseOver = () => {};
  return (
    <Card href={link} onMouseOver={handleMouseOver} target="_blank">
      <img
        src={value}
        link={link}
        style={{ width: "inherit", height: "inherit" }}
        alt=""
      />
      <CardDetails>
        <h1>{proName}</h1>
        <h3>Click To Open</h3>
      </CardDetails>
    </Card>
  );
}
const Card = Styled.a`
    width:22rem;
    height:15rem;
    border-radius:10px;
    overflow:hidden;
    box-shadow:0 0 5px 0.5px #ffffff40;
    transition:cubic-bezier(0.51, 0.09, 0.75, 0.99) .5s;
    &:hover{
        transform:scale(1.1);
    }
    img{
        transition:all 1s;
        cursor:pointer;
        position:absolute;
        border-radius:10px;
        background:white;
        z-index:10;
        &:hover{
            opacity:0;
        }
    }
    @media (max-width:425px){
      width:20rem;
      height:12rem;
    }
`;
const CardDetails = Styled.div`
    color:white;
    width:inherit;
    background:#ffb400;
    height:inherit;
    position:absolute;
    border-radius:10px;
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    text-transform:uppercase;
    font-family:sans-serif;
    &:hover{
        z-index:11;
        background-color:#ffb400;
    }
    @media (max-width:425px){
      width:20rem;
      height:12rem;
    }
`;
export default ProjectCard;
